import { facetNames, formatters } from 'modules/formatting'
import _ from 'lodash'

const defaultVisibleCharts = ['financial_status', 'processing_method', 'source_name', 'fulfillment_status', 'billing_country_code', 'billing_province', 'shipping_country_code', 'sold_hour']
export const initialChartConfigs = Object.assign({}, facetNames.reduce((acc, cur, index) => ({
  ...acc,
  [cur]: { visible: defaultVisibleCharts.includes(cur), chart_type: _.get(formatters.facets, [cur, 'default_chart'], 'column'), metric: 'total_orders', order: index }
}), {}))
/**
 * Set chart_type for one or more facets, returning a NEW config.
 *
 * Two things this must not do, both of which broke the chart-type toggle:
 *  - assume the facet already has a config entry. Saved configs only contain the
 *    facets a user has touched, so toggling a chart like sales_channel_platform
 *    threw on `charts[facetName].chart_type = …` and the click did nothing.
 *  - mutate in place. The Overview's summary selector is memoized on the identity
 *    of config.charts, so an in-place edit left it serving a cached summary with
 *    the old chart_type (and, when config was undefined, it wrote into the shared
 *    initialChartConfigs module object).
 */
export const updateConfigChartType = (config, newChartType) => {
  const base = config || {}
  const charts = { ...(base.charts || initialChartConfigs) }
  for (const facetName in newChartType) {
    charts[facetName] = {
      ...(charts[facetName] || initialChartConfigs[facetName] || { visible: true, metric: 'total_orders' }),
      chart_type: newChartType[facetName],
    }
  }
  return { ...base, charts }
}